import React, {PropTypes} from 'react';
import ScheduleEventListContainer from './ScheduleEventListContainer.jsx';
import VirtualEventContainer from './VirtualEventContainer.jsx';
import EventPriceDetailsModalContainer from 'shared/eventPriceDetailsModal/EventPriceDetailsModalContainer.jsx';
import RegistrationCalendarContainer from './RegistrationCalendarContainer.jsx';
import CartFooterContainer from './CartFooterContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const Scheduler = ({
  noDatesAvailable,
  marketingMessage,
  canCaptainPurchase
}) => (
  <div>
    <div className="animated fadeIn">

      <DisplayIf condition={!!marketingMessage || noDatesAvailable || !canCaptainPurchase}>
        <div className="row">
          <div className="col-sm-12 animated fadeIn">
              <div className="alert alert-info text-center">
                { marketingMessage ? <p>{marketingMessage}</p> : null }
                { noDatesAvailable ? <p>{'No bowled events available for this tournament.'}</p> : null }
                { !canCaptainPurchase ? <p>{'Tournament is not available for purchase at this time. Please call USBC if you have any questions.'}</p> : null }
              </div>
          </div>
        </div>
      </DisplayIf>

      <DisplayIf condition={canCaptainPurchase}>
        {
          noDatesAvailable
          ? <div>
              <VirtualEventContainer />
              <CartFooterContainer />
            </div>
          : <div>
              <div className="row">
                <div className="col-md-4">
                  <RegistrationCalendarContainer />
                </div>
                <div className="col-md-8">
                  <ScheduleEventListContainer />
                  <VirtualEventContainer />
                  <CartFooterContainer />
                </div>
              </div>
              <EventPriceDetailsModalContainer />
            </div>
        }
      </DisplayIf>
    </div>
  </div>
);

Scheduler.propTypes = {
  noDatesAvailable: PropTypes.bool,
  marketingMessage: PropTypes.string,
  canCaptainPurchase: PropTypes.bool
};

export default Scheduler;



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/Scheduler.jsx